import { render, staticRenderFns } from "./ModalAssignPerson.vue?vue&type=template&id=5d3a7bdb&scoped=true"
import script from "./ModalAssignPerson.vue?vue&type=script&lang=js"
export * from "./ModalAssignPerson.vue?vue&type=script&lang=js"
import style0 from "./ModalAssignPerson.vue?vue&type=style&index=0&id=5d3a7bdb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3a7bdb",
  null
  
)

export default component.exports